export default __webpack_public_path__ + "static/media/WorkSpace.3dc814a0.png";